import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { LoginSessionFacadeService } from '@digital-platform/users/services';

@Component({
  selector: 'digital-platform-onboarding-dialog',
  templateUrl: './onboarding-dialog.component.html',
  styleUrls: ['./onboarding-dialog.component.scss'],
})
export class OnboardingDialogComponent {
  constructor(
    private readonly removeDialogRef: MatDialogRef<OnboardingDialogComponent>,
    private readonly facade: LoginSessionFacadeService
  ) {}

  public closeDialog() {
    this.facade.onboardingComplete(true);
    sessionStorage.setItem('onboardingComplete', 'true');
    this.removeDialogRef.close();
  }
}
